import { ALLOCATE_SHIPPING_UNIT_LIST_COLUMN } from "./actionTypes";

export const setListAllocateShippingUnitColumn = (field, value) => ({
  type: ALLOCATE_SHIPPING_UNIT_LIST_COLUMN,
  payload: { field, value },
});
